/* Drømmehave — kurv-drawer og søge-overlay.
   Laa foer inline i snippets/dh-overlays.liquid og blev dermed sendt
   ucachet med i HTML'en paa HVER sidevisning. Som asset hentes den én
   gang og genbruges fra cachen resten af besoeget.
   Valuta og kurv-adresse kommer fra data-attributter paa
   [data-dh-overlay], fordi en .js-fil ikke kan laese Liquid.
   Skal pushes SAMMEN med snippets/dh-overlays.liquid. */
(function () {
  var overlay = document.querySelector('[data-dh-overlay]');
  var cart = document.getElementById('dh-cart');
  var search = document.getElementById('dh-searchpanel');
  var current = null;

  // Valuta og kurv-adresse kom fra Liquid, da dette script laa inline i
  // snippet'en. De laeses nu fra overlay-elementet, saa filen kan ligge som
  // et cachet asset i stedet for at blive sendt med i hver sides HTML.
  var VALUTA = overlay ? (overlay.getAttribute('data-dh-currency') || '') : '';
  var KURV_URL = (overlay && overlay.getAttribute('data-dh-cart-url')) || '/cart';

  function show(panel) {
    if (!panel) return;
    current = panel;
    // Flyt panel og overlay sidst i <body>. Butikkens apps bruger samme
    // maksimale z-index som os, og ved uafgjort vinder den der står sidst
    // i DOM'en — ellers lægger fx nyhedsbrevs-popup'en sig over kurven.
    document.body.appendChild(overlay);
    document.body.appendChild(panel);
    panel.hidden = false; overlay.hidden = false;
    // Tving et layout-gennemløb i stedet for requestAnimationFrame: rAF er
    // sat på pause når fanen er i baggrunden, og så ville panelet aldrig
    // blive synligt. void offsetWidth giver samme animation, altid.
    void panel.offsetWidth;
    panel.setAttribute('data-open', 'true');
    overlay.setAttribute('data-open', 'true');
    // Sikkerhedsnet: hvis transitionen aldrig kører (baggrundsfane, spared
    // motion, langsom enhed) ville panelet blive stående uden for skærmen.
    // Efter animationens længde tvinges sluttilstanden igennem.
    window.setTimeout(function () {
      if (panel.getAttribute('data-open') !== 'true') return;
      // Transitionen SKAL slås fra først — ellers animerer vi bare mod den
      // nye værdi og bliver stående samme sted, når der ikke tegnes frames.
      var stod = panel.getBoundingClientRect();
      if (stod.left >= window.innerWidth || stod.bottom <= 0) {
        panel.style.transition = 'none';
        overlay.style.transition = 'none';
        panel.style.transform = 'translate(0, 0)';
        overlay.style.opacity = '1';
        void panel.offsetWidth;
        panel.style.transition = '';
        overlay.style.transition = '';
      }
    }, 280);
    document.body.setAttribute('data-dh-locked', 'true');
    if (window.dhLaas) window.dhLaas(true);
    var rul = panel.querySelector('[data-dh-cart-rul]');
    if (rul) rul.scrollTop = 0;
    var focusable = panel.querySelector('input, button');
    if (focusable) focusable.focus();
  }

  // Shopifys svar, når noget ikke kan lægges i eller ændres — fx "Det
  // maksimale antal af denne vare er allerede i din indkøbskurv" ved
  // lagergrænsen. Før blev svaret smidt væk, og kunden så enten ingenting
  // eller "prøv igen" (18/9-2026).
  var fejlTimer = null;
  function visKurvFejl(tekst) {
    var el = document.querySelector('[data-dh-cart-fejl]');
    if (!el) return;
    window.clearTimeout(fejlTimer);
    if (!tekst) { el.hidden = true; el.textContent = ''; return; }
    el.textContent = tekst; el.hidden = false;
    fejlTimer = window.setTimeout(function () { el.hidden = true; }, 8000);
  }
  function visAddFejl(tekst) {
    document.querySelectorAll('[data-dh-add-fejl]').forEach(function (el) {
      el.textContent = tekst || ''; el.hidden = !tekst;
    });
  }
  // Beregnernes knapper: en fejlbesked lige under knappen, i stedet for at
  // klemme Shopifys sætning ind i selve knappen.
  function fejlVed(knap, tekst) {
    if (!knap) return;
    var el = knap.nextElementSibling;
    if (!el || !el.hasAttribute('data-dh-kurvfejl')) {
      el = document.createElement('p');
      el.className = 'dh-kurvfejl';
      el.setAttribute('data-dh-kurvfejl', '');
      el.setAttribute('role', 'alert');
      knap.insertAdjacentElement('afterend', el);
    }
    if (!tekst) { el.hidden = true; return; }
    el.textContent = tekst; el.hidden = false;
  }
  /* Kun 422-svarene (lagergrænse o.l.) kommer på butikkens sprog. Shopifys
     bremse ved mange kald (429: "Please try again in a few minutes"),
     "bad_request" og serverfejl svarer på engelsk — og message er altid den
     engelske overskrift ("Cart Error"). Dér bruges kaldets egen danske tekst
     (2/10-2026). status kan gives med, når svaret ikke selv har den. */
  function svarTekst(j, ellers, status) {
    if (!j) return ellers;
    var s = String(status || j.status || '');
    if (s && s !== '422') return ellers;
    return j.description || ellers;
  }
  function hide() {
    if (!current) return;
    current.style.transform = '';
    current.style.transition = '';
    overlay.style.opacity = '';
    overlay.style.transition = '';
    current.setAttribute('data-open', 'false');
    overlay.setAttribute('data-open', 'false');
    document.body.removeAttribute('data-dh-locked');
    if (window.dhLaas) window.dhLaas(false);
    var p = current; current = null;
    window.setTimeout(function () { p.hidden = true; overlay.hidden = true; }, 240);
  }

  // Kurven åbner også ved hover på pegeenheder med hover (ikke touch, hvor
  // hover ellers ville trigge på første tap og stjæle klikket).
  var hovertimer = null;
  if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    document.addEventListener('mouseover', function (e) {
      if (!e.target.closest('[data-dh-cart-open]')) return;
      window.clearTimeout(hovertimer);
      hovertimer = window.setTimeout(function () { show(cart); }, 180);
    });
    document.addEventListener('mouseout', function (e) {
      if (e.target.closest('[data-dh-cart-open]')) window.clearTimeout(hovertimer);
    });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-dh-cart-open]')) {
      e.preventDefault();
      window.clearTimeout(hovertimer);
      show(cart);
      /* Kurven kan være ændret siden siden blev tegnet — i en anden fane,
         af en app, eller fordi man kom tilbage med browserens tilbage-knap.
         Derfor hentes den friske udgave, hver gang draweren åbnes. */
      refreshCart();
    }
    if (e.target.closest('[data-dh-search-open]')) { e.preventDefault(); show(search); }
    if (e.target.closest('[data-dh-cart-close],[data-dh-search-close]')) { e.preventDefault(); hide(); }
    if (e.target === overlay) hide();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') hide(); });

  // Både antal OG beløb i headeren skal følge med — beløbet blev glemt før.
  function opdaterHeader(c) {
    document.querySelectorAll('[data-dh-cart-count]').forEach(function (el) { el.textContent = c.item_count; });
    var kr = (c.total_price / 100).toLocaleString('da-DK', {minimumFractionDigits: 2, maximumFractionDigits: 2});
    document.querySelectorAll('[data-dh-cart-total]').forEach(function (el) {
      el.textContent = kr + ' ' + VALUTA;
    });
  }

  // ---- kurv: opdatér antal uden at forlade siden
  function tegnKurv() {
    return fetch(KURV_URL + '?view=dh-json', {headers: {'X-Requested-With': 'XMLHttpRequest'}})
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var body = doc.querySelector('[data-dh-cart-body]');
        var foot = doc.querySelector('[data-dh-cart-foot]');
        var fast = doc.querySelector('[data-dh-cart-sticky]');
        if (body) document.querySelector('[data-dh-cart-body]').innerHTML = body.innerHTML;
        if (foot) document.querySelector('[data-dh-cart-foot]').innerHTML = foot.innerHTML;
        if (fast && document.querySelector('[data-dh-cart-sticky]')) document.querySelector('[data-dh-cart-sticky]').innerHTML = fast.innerHTML;
        laasCheckout();          /* fodnoten er ny markup — låsen skal sættes igen */
      });
  }

  function refreshCart() {
    // Tegn, afstem emballagen, og tegn igen hvis der blev rettet noget.
    // Kun én ekstra runde — så kan en fejl i data ikke sende os i ring.
    return tegnKurv()
      .then(afstemEmballage)
      .then(function (rettet) {
        if (!rettet) return;
        return tegnKurv().then(function () {
          return fetch('/cart.js').then(function (r) { return r.json(); }).then(opdaterHeader);
        });
      })
      .catch(function () { window.location.href = KURV_URL; });
  }

  // ---- handelsbetingelser låser checkout op
  function laasCheckout() {
    var box = document.querySelector('[data-dh-terms]');
    var knap = document.querySelector('[data-dh-checkout]');
    if (!knap) return;
    var ok = !box || box.checked;
    knap.setAttribute('aria-disabled', ok ? 'false' : 'true');
  }
  document.addEventListener('change', function (e) {
    if (e.target.closest('[data-dh-terms]')) laasCheckout();
  });
  document.addEventListener('click', function (e) {
    var knap = e.target.closest('[data-dh-checkout]');
    if (!knap) return;
    if (knap.getAttribute('aria-disabled') === 'true') {
      e.preventDefault();
      var box = document.querySelector('[data-dh-terms]');
      if (box) { box.focus(); box.closest('.dh-cart__terms').classList.add('dh-cart__terms--kraev'); }
    }
  });

  // ---- bemærkning til sælger, gemt når feltet forlades
  document.addEventListener('change', function (e) {
    var felt = e.target.closest('[data-dh-cart-note]');
    if (!felt) return;
    fetch('/cart/update.js', {
      method: 'POST', headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({note: felt.value})
    }).then(function () {
      var kvit = document.querySelector('[data-dh-note-status]');
      if (!kvit) return;
      kvit.hidden = false;
      setTimeout(function () { kvit.hidden = true; }, 2000);
    });
  });

  // Gebyr-appen retter selv kurven efter vores skrivning — den fjerner fx
  // anbrudsgebyret, når antallet er fyldt op til en hel palle. Det sker et
  // øjeblik senere, så tegner vi med det samme, viser vi et forældet beløb.
  // Her ventes til to målinger i træk er ens, dog højst nogle få forsøg.
  function afventGebyrApp(runder) {
    var tilbage = runder || 4;
    function maal() {
      return fetch('/cart.js').then(function (r) { return r.json(); })
        .then(function (c) { return c.item_count + ':' + c.items_subtotal_price; });
    }
    function runde(forrige) {
      if (tilbage-- <= 0) return Promise.resolve();
      return new Promise(function (klar) { setTimeout(klar, 600); })
        .then(maal)
        .then(function (nu) { return nu === forrige ? undefined : runde(nu); });
    }
    return maal().then(runde).catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-dh-line-qty]');
    if (!btn) return;
    e.preventDefault();
    var key = btn.dataset.key;
    var qty = parseInt(btn.dataset.dhLineQty, 10);
    var erAnbrud = btn.classList.contains('dh-cart__anbrudknap');
    if (erAnbrud) btn.disabled = true;
    fetch('/cart/change.js', {
      method: 'POST', headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({id: key, quantity: qty})
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j, status: r.status }; }); })
      .then(function (svar) {
        if (!svar.ok) {
          /* fx lagergrænsen: Shopify forklarer selv hvorfor */
          visKurvFejl(svarTekst(svar.j, 'Antallet kunne ikke ændres — prøv igen.', svar.status));
          if (erAnbrud) btn.disabled = false;
          return refreshCart();
        }
        visKurvFejl('');
        var c = svar.j;
        opdaterHeader(c);
        if (!erAnbrud) return refreshCart();
        return afventGebyrApp().then(function () {
          return fetch('/cart.js').then(function (r) { return r.json(); }).then(opdaterHeader);
        }).then(refreshCart);
      });
  });

  // ---------------------------------------------------------------- emballage
  // Kurven kan ændres af kunden bagefter — antal op, antal ned, vare fjernet.
  // Emballagen skal følge med, så den afstemmes hver gang kurven er tegnet om.
  // Behovet står i markup'en fra dh-cart-lines, hvor metafelterne findes.
  var afstemLaas = false;

  function afstemEmballage() {
    if (afstemLaas) return Promise.resolve(false);

    // På /cart findes kurven både i sidens markup og i drawer'en. Tælles
    // begge, bliver behovet dobbelt så stort. Drawer'en vinder, når den er
    // tegnet, ellers bruges sidens egen.
    var rod = document.querySelector('[data-dh-cart-body] [data-dh-pack-behov]');
    if (!rod) rod = document.querySelector('[data-dh-pack-behov]');
    if (!rod) return Promise.resolve(false);
    var linjeRod = rod.closest('[data-dh-cart-body]') || document;

    var behov = {};
    rod.querySelectorAll('[data-pak]').forEach(function (el) {
      var id = el.getAttribute('data-pak');
      behov[id] = (behov[id] || 0) + (parseInt(el.getAttribute('data-n'), 10) || 0);
    });

    var rettelser = [];
    var set = {};
    linjeRod.querySelectorAll('[data-dh-pack-line]').forEach(function (el) {
      var id = el.getAttribute('data-dh-pack-line');
      var oensket = behov[id] || 0;
      set[id] = true;
      var nu = parseInt(el.getAttribute('data-antal') || '-1', 10);
      rettelser.push({key: el.getAttribute('data-key'), id: id, antal: oensket, nu: nu});
    });

    // Mangler der en emballagelinje helt, lægges den i
    var mangler = Object.keys(behov).filter(function (id) { return !set[id] && behov[id] > 0; });

    var kaldene = [];
    rettelser.forEach(function (r) {
      if (r.antal === r.nu) return;
      kaldene.push(function () {
        return fetch('/cart/change.js', {
          method: 'POST', headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({id: r.key, quantity: r.antal})
        });
      });
    });
    if (mangler.length) {
      kaldene.push(function () {
        return fetch('/cart/add.js', {
          method: 'POST', headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({items: mangler.map(function (id) {
            return {id: Number(id), quantity: behov[id], properties: {_dh_emballage: 'auto'}};
          })})
        });
      });
    }
    if (!kaldene.length) return Promise.resolve(false);

    // Én ad gangen: Shopify afviser samtidige kurvskrivninger med 422.
    afstemLaas = true;
    return kaldene.reduce(function (kaede, f) { return kaede.then(f); }, Promise.resolve())
      .then(function () { afstemLaas = false; return true; })
      .catch(function () { afstemLaas = false; return false; });
  }

  // På /cart tegnes kurven af Liquid, ikke af drawer-flowet, så afstemningen
  // skal sættes i gang her. Ellers står en kunde der lander direkte på /cart
  // — fx fra en beregner — uden den emballage, varen kræver.
  (function afstemPaaKurvside() {
    if (!document.querySelector('.dh-cartpage')) return;
    var NOEGLE = 'dh-pack-genindlaest';
    afstemEmballage().then(function (rettet) {
      if (!rettet) { sessionStorage.removeItem(NOEGLE); return; }
      if (sessionStorage.getItem(NOEGLE)) return;   // kun én genindlæsning
      sessionStorage.setItem(NOEGLE, '1');
      window.location.reload();
    });
  })();

  // Læg-i-kurv åbner drawer i stedet for at skifte side
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('#dh-add-form');
    if (!form) return;
    e.preventDefault();
    var fd = new FormData(form);
    var pakId = form.dataset.dhPackVariant;
    var pakAntal = parseInt(form.dataset.dhPackQty || '0', 10);

    var kald;
    if (pakId && pakAntal > 0) {
      // Emballagen lægges i samme kald som varen, så kurven aldrig når at
      // stå med den ene uden den anden. Antallet er antal paller.
      kald = fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({items: [
          {id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1)},
          {id: Number(pakId), quantity: pakAntal, properties: {_dh_emballage: 'auto'}}
        ]})
      });
    } else {
      kald = fetch('/cart/add.js', {method: 'POST', body: fd});
    }

    kald
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j, status: r.status }; }); })
      .then(function (svar) {
        if (!svar.ok) {
          /* Shopify siger fx "Det maksimale antal af denne vare er allerede
             i din indkøbskurv" — den besked hører hjemme ved knappen. */
          var fejltekst = svarTekst(svar.j, 'Varen kunne ikke lægges i kurven — prøv igen.', svar.status);
          visAddFejl(fejltekst);
          /* Ved lagergrænsen kan Shopify have lagt en DEL af antallet i kurven
             (fx 10 af 56 fliser) og alligevel svare 422. Så skal headeren og
             emballagen følge det, der faktisk kom i — ellers viste headeren 0,
             og pallerne passede til det fulde antal (2/10-2026).
             Headeren opdateres altid. Kurven tegnes, afstemmes og åbnes kun,
             når der faktisk kom noget i: refreshCart() sender kunden til /cart,
             hvis afstemningen fejler — og det må ikke ske ved fx en 429, hvor
             intet blev lagt i. Beskeden gentages i kurven, så kunden kan se,
             hvorfor antallet er mindre. */
          var foer = parseInt((document.querySelector('[data-dh-cart-count]') || {}).textContent, 10);
          fetch('/cart.js').then(function (r) { return r.json(); })
            .then(function (c) {
              opdaterHeader(c);
              if (c.item_count > 0 && (isNaN(foer) || c.item_count > foer)) {
                refreshCart(); show(cart); visKurvFejl(fejltekst);
              }
            })
            .catch(function () {});
          return;
        }
        visAddFejl('');
        return fetch('/cart.js').then(function (r) { return r.json(); })
          .then(function (c) { opdaterHeader(c); refreshCart(); show(cart); });
      })
      .catch(function () { form.submit(); });
  });

  // Beregnerne (Farum Natur, IBF, kantsten, mængde, pigsten, trappe, projekt,
  // chaussesten-tilbehør …) lægger selv i kurven med fetch og melder det med
  // en hændelse. Fire navne er i omløb — alle fører hertil: headerens tal
  // opdateres, og kurven åbnes, så kunden kan SE, at varen er lagt i. Før
  // lyttede ingen; kunden så kun en lille kvittering og trykkede igen, til
  // lageret var brugt op (18/9-2026).
  ['dh:cart:updated', 'dh:cart:changed', 'dh:cart-updated', 'cart:refresh'].forEach(function (navn) {
    document.addEventListener(navn, function () {
      fetch('/cart.js').then(function (r) { return r.json(); }).then(opdaterHeader).catch(function () {});
      refreshCart();
      if (cart && cart.getAttribute('data-open') !== 'true') show(cart);
    });
  });
  window.dhKurv = { opdater: refreshCart, vis: function () { show(cart); refreshCart(); },
                    fejl: visKurvFejl, fejlVed: fejlVed, svarTekst: svarTekst };

  // ---- søgning: live-resultater
  var input = document.getElementById('dh-search-overlay');
  var results = document.querySelector('[data-dh-search-results]');
  var timer = null;
  var standardHTML = results ? results.innerHTML : '';

  /* suggest.json giver prisen som "2299.00" — den stod sådan i panelet, mens
     listen ovenover (Liquid) skriver "fra 2.599,00 DKK". Samme form her:
     dansk talformat, butikkens valuta og ordet foran, når varianterne koster
     forskelligt. Ordet er en indstilling i headeren (data-dh-pris-fra). */
  var FRA = (document.querySelector('[data-dh-pris-fra]') || {getAttribute: function () { return ''; }})
              .getAttribute('data-dh-pris-fra') || '';
  function kr(x) {
    var n = parseFloat(String(x).replace(',', '.'));
    if (isNaN(n)) return '';
    return n.toLocaleString('da-DK', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + (VALUTA ? ' ' + VALUTA : '');
  }
  function pris(p) {
    var fra = FRA && p.price_max && p.price_min && parseFloat(p.price_max) > parseFloat(p.price_min);
    return (fra ? FRA + ' ' : '') + kr(p.price_min || p.price);
  }
  if (input) input.addEventListener('input', function () {
    var q = input.value.trim();
    window.clearTimeout(timer);
    // Tomt felt → tilbage til bedst sælgende i stedet for en tom liste
    if (q.length < 2) { results.innerHTML = standardHTML; return; }
    timer = window.setTimeout(function () {
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var items = (d.resources.results.products || []);
          if (!items.length) { results.innerHTML = '<p class="dh-sres__head">Ingen varer matcher \u201d' + q + '\u201d.</p>'; return; }
          results.innerHTML = '<p class="dh-sres__head">' + items.length + ' varer matcher</p>' + items.map(function (p) {
            return '<a class="dh-sres__row" href="' + p.url + '">' +
              '<img src="' + (p.featured_image ? p.featured_image.url : '') + '" alt="" width="52" height="52">' +
              '<span><span class="dh-sres__name">' + p.title + '</span><br>' +
              '<span class="dh-sres__meta">' + (p.product_type || '') + '</span></span>' +
              '<span class="dh-sres__price">' + (p.price ? pris(p) : '') + '</span></a>';
          }).join('');
        });
    }, 220);
  });
})();
